import { GET_SHOW_MENU_ID, GET_CURRENT_MODULE } from "./types";

export default {
  [GET_SHOW_MENU_ID]: (state) => state.show_menu_id,
  [GET_CURRENT_MODULE]: (state) => state.current_module,
};
